module.exports = __webpack_public_path__ + "img/電気回路_3_3_5.51527d0e.png";